import { defineComponent, inject } from 'vue';
import LayoutMobile from './mobile.vue';
import LayoutPc from './pc.vue';
export default defineComponent({
    name: 'LayoutComp',
    components: {
        LayoutMobile,
        LayoutPc
    },
    setup () {
        const isMobile = inject('isMobile');
        return {
            isMobile
        };
    }
});
